<script>
import _ from 'lodash'
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    numberlimit: {
      default: 2,
      type: Number,
    },
    percent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    themeBlack() {
      return this.$store.state.layout.themeBlack
    },
    options() {
      const that = this
      return {
        scales: {
          xAxes: [
            {
              ticks: {
                autoSkip: true,
                distribution: 'linear',
                autoSkipPadding: 10,
                mirror: true,
                maxRotation: 0,
                minRotation: 0,
                fontColor: this.themeBlack ? '#d1d4dd' : '#000000',
              },
              type: 'time',
              distribution: 'series',
              time: {
                unit: 'day',
                displayFormats: {
                  day: 'DD.MM',
                },
                tooltipFormat: 'DD.MM.YY HH:mm',
              },
              gridLines: {
                display: false,
                color: this.themeBlack ? '#d1d4dd' : '#000000',
              },
            },
          ],
          yAxes: [
            {
              position: 'right',
              ticks: {
                autoSkip: true,
                autoSkipPadding: 30,
                fontColor: this.themeBlack ? '#d1d4dd' : '#000000',
                padding: 6,
              },
              gridLines: {
                color: this.themeBlack ? '#d1d4dd77' : '#00000044',
                display: true,
                drawTicks: false,
                drawBorder: false,
              },
            },
          ],
        },
        legend: false,
        elements: {
          point: {
            radius: 0,
          },
        },
        tooltips: {
          mode: 'nearest',
          intersect: false,
          callbacks: {
            label({ yLabel }) {
              return `${Number(yLabel).toFixed(that.numberlimit)}${
                that.percent ? ' %' : ''
              }`
            },
          },
        },
        maintainAspectRatio: false,
        // responsive: true,
      }
    },
  },
  mounted() {
    this.prepare()
    this.draw()
  },
  methods: {
    prepare() {
      // this.chartData is created in the mixin.
      // If you want to pass options please create a local options object
      this.gradient = this.$refs.canvas
        .getContext('2d')
        .createLinearGradient(0, 0, 0, 200)
      this.gradient.addColorStop(0, 'rgba(0,166,203, 1)')
      this.gradient.addColorStop(0.7, 'rgba(0,166,203, 0.3)')
      this.gradient.addColorStop(1, 'rgba(0,166,203, 0.08)')
    },
    draw() {
      const chartData = {
        ...this.chartData,
        datasets: Array.from(_.get(this, 'chartData.datasets', [])).map(
          (el) => ({
            ...el,
            backgroundColor: this.gradient,
            borderColor: 'rgb(0,166,203)',
            borderWidth: 1,
            lineTension: 0.2,
          })
        ),
      }
      this.renderChart(chartData, this.options)
    },
  },
  watch: {
    chartData() {
      this.$data._chart.update()
    },
    themeBlack() {
      this.draw()
    },
  },
}
</script>

<style></style>
